import { createRouter, createWebHashHistory } from "vue-router";
import Cookies from 'js-cookie'

const Login = () => import("../views/login/index.vue");
const Page404 = () => import("../views/error/404.vue");
const PrintPage = () => import("../views/PrintPage");

// const NoOrg = () => import("../views/NoOrg");
const modules = [];

const modulesFiles = require.context('./modules', true, /.js$/)
modulesFiles.keys().forEach((key) => {
  modules.push(modulesFiles(key).default)
})

const routes = [
  {
    path: "/login",
    name: 'login',
    component: Login,
  },
  {
    path: "/print",
    component: PrintPage,
  },
  // {
  //   path: "/noorg",
  //   name: 'noorg',
  //   component: NoOrg,
  // },
  ...modules,
  {
    path: "/error404",
    name: 'error404',
    component: Page404,
  },
  { path: "/:pathMath(.*)", redirect: "/error404" },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 无需校验
const noCheckRouter = [
  'login'
]

// 机构校验
const noOrgRouter = [
  'noorg'
]

router.beforeEach((to, from, next) => {
  const authorization = Cookies.get('Authorization')
  const eduOrganization = Cookies.get('EDU-ORGANIZATION') || ''

  if (noOrgRouter.includes(to.name)) {
    if (authorization) {
      if (eduOrganization) {
        next({ name: 'home' })
      } else {
        next()
      }
    } else {
      next({ name: 'login' })
    }
    return
  }
  if (noCheckRouter.includes(to.name)) {
    if (authorization) {
      if (eduOrganization) {
        next({ name: 'home' })
      } else {
        next({ name: 'noorg' })
      }
    } else {
      next()
    }
    return
  }
  // 校验用户信息
  if (!authorization) {
    next({ name: 'login' })
  } else {
    if (!eduOrganization) {
      next({ name: 'noorg' })
    } else {
      next()
    }
  }
});

export default router;
